jQuery(document).ready(() => {
	let activeTermsPosts = [];
	$('.news-filters__item').on('click', function () {
		let dataIdPosts = $(this).data('filter');
		const postsType = $('.news-filters').data('type'),
			taxonomyPosts = $('.news-filters').data('taxonomy');
		$(this).toggleClass('active');
		if ($(this).hasClass('active')) {
			activeTermsPosts.push(dataIdPosts);
		} else {
			activeTermsPosts.splice($.inArray(dataIdPosts, activeTermsPosts), 1);
		}
		$.ajax({
			url: themeVars.ajaxurl,
			type: "POST",
			data: {
				action: "filter_posts_term",
				post_type: postsType,
				taxonomy: taxonomyPosts,
				terms: activeTermsPosts,
			},
			success: function (data) {
				$('.blog-page__row').html(data.posts_html);
			},
		});
	});
});



// WEBPACK FOOTER //
// ./scripts/modules/filter-posts-term.js